import {
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-add-app-role-access',
  templateUrl: './add-app-role-access.component.html',
  styleUrls: ['./add-app-role-access.component.css'],
})
export class AddAppRoleAccessComponent extends BaseListCtl {
  @Input() curApp: any;

  @Input() currentRoleData: any;
  public applicationsroles: any = [];
  public usecases: any = [];
  public forms: any = [];
  public datavalidate: boolean | undefined;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super(
      locator.config.get('endpoint.application.role.usecase'),
      locator,
      route,
    );
    let _self = this;
    _self.form.data['applicationId'] = 0;
    _self.form.data['create'] = 0;
    _self.form.data['update'] = 0;
    _self.form.data['read'] = 1;
    _self.form.data['delete'] = 0;
  }

  /**
   * Convert the form data to JSON
   * @param field
   */
  async convertStringToNumber(field: string): Promise<void> {
    if (this.form.data[field]) {
      this.form.data[field] = +this.form.data[field];
    }
    await this.detectChange();
  }

  /**
   * Get the list of applications.
   */
  public async getApplicationRole() {
    let _self = this;
    // get applications
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/application-roles/' +
      _self.curApp['id'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationsroles = res.result.data;
    });
  }

  /**
   * Get usecases list
   */
  public async getUsecases() {
    let _self = this;
    // get applications
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/usecases/' +
      this.curApp['id'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecases = res.result.data;
    });
  }

  /**
   * Set API and get forms
   * @param apiId
   */
  public async getForms(apiId: any) {
    this.form.data['formId'] = undefined;
    // this.forms = [];

    let _self = this;
    await this.detectChange();
    await _self.usecases.forEach((e: any) => {
      if (e.id === Number(apiId)) {
        _self.form.data['apiName'] = e.name;
      }
    });

    _self.convertStringToNumber('apiId');
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/formsbyusecase/' +
      Number(apiId);
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.forms = res.result.data;
    });
  }

  /**
   * On changes
   * @param changes
   */
  public async ngOnChanges(changes: SimpleChanges) {
    let _self = this;
    if (changes['curApp']) {
      //this.preload();
      this.resetForm();
      this.search();
      this.getApplicationRole();
      this.getUsecases();
    }
  }

  /**
   * On init
   */
  override ngOnInit() {
    //this.preload();
    this.search();
    this.getApplicationRole();
    this.getUsecases();
  }

  /**
   * override Search to add applicationId in searchParams
   */
  override search(): void {
    let _self = this;
    ((this.form.searchParams['applicationId'] = Number(this.curApp['id'])),
      super.search(function (error: any) {
        if (_self.form.searchMessage === 'Record not found') {
          _self.form.list = [];
        }
      }));
  }

  /**
   * Save
   * @param callback
   */
  override async save(callback?: any) {
    var _self = this;
    await _self.detectChange();
    await _self.checkDuplicate();
    if (_self.datavalidate) {
      _self.form.error = false;
      _self.form.message = '';
      _self.form.inputerror = {};
      this.form.data['applicationId'] = this.curApp['id'];
      this.form.data['applicationName'] = this.curApp['name'];
      this.locator.config
        .getProperty('endpoint.application.role.usecase')
        .then((property: string) => {
          this.locator.http.post(
            property + '/save',
            this.form.data,
            function (res: any, error: any) {
              if (error) {
                return;
              }

              _self.form.error = !res.success;
              _self.form.message = res.result.message;

              if (res.success) {
                _self.form.message = 'Data is saved';
                _self.search();
                _self.resetForm();
                // Set a 2-second delay to call clearMessage
                setTimeout(() => {
                  _self.clearMessage(_self.form);
                }, 5000);
                if (callback) {
                  callback();
                }
              } else {
                _self.form.inputerror = res.result.inputerror;
              }
            },
          );
        });
    }
  }

  /**
   * Check dulplicate from list
   * @returns
   */
  public async checkDuplicate() {
    var _self = this;

    await _self.detectChange();

    const wait = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));

    const findUser = async () => {
      return _self.form.list.find(
        (access: {
          applicationId: any;
          applicationRoleId: any;
          userstoryId: any;
          formId: any;
        }) =>
          access?.applicationId === this.curApp['id'] &&
          access?.applicationRoleId === _self.form.data.applicationRoleId &&
          access?.userstoryId === _self.form.data.userstoryId &&
          access?.formId === _self.form.data.formId,
      );
    };

    const user = await findUser();

    // If a user is found, handle the duplicate scenario
    if (user) {
      _self.datavalidate = false;
      _self.form.error = true;
      _self.form.message = 'Duplicate application role access is not allowed';
      console.error('Access found:', user);
      return _self.datavalidate; // return early if duplicate is found
    } else {
      // If no duplicate is found, clear the error
      _self.datavalidate = true;
      _self.form.error = false;
      _self.form.message = '';
      console.error('User not found');
      return _self.datavalidate; // return the validated state
    }
  }

  /**
   * Change detector
   */
  async detectChange() {
    this.cdr.detectChanges();
  }

  /**
   * Covert value yes / no to number value 1 / 0
   * @param field
   */
  convertBooleanToNumber(field: string) {
    this.form.data[field] = this.form.data[field] ? 1 : 0;
  }

  /**
   * override reset for default value
   */
  override resetForm(): void {
    super.resetForm();
    this.form.data['applicationId'] = 0;
    this.form.data['create'] = 0;
    this.form.data['update'] = 0;
    this.form.data['read'] = 1;
    this.form.data['delete'] = 0;
  }

  canView(): boolean {
    return this.currentRoleData?.read === 1;
  }

  canCreate(): boolean {
    return this.currentRoleData?.create === 1;
  }

  canUpdate(): boolean {
    return this.currentRoleData?.update === 1;
  }

  canDelete(): boolean {
    return this.currentRoleData?.delete === 1;
  }
}
